export default {
  intel: '/intel',
  intelProperties: '/intel/property',
  intelNeighborhood: '/intel/neighborhood',
  intelReminders: '/intel/reminders',
};
